var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Image, Link, PlayDuration } from "core/components";
import { colors, fontWeight, mq } from "core/styles/snippets";
import React from "react";
import styled from "styled-components";
var ListItem = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n"], ["\n  list-style: none;\n"])));
var wrapInListItem = function (element, shouldWrap) {
    return shouldWrap ? React.createElement(ListItem, null, element) : element;
};
export var Card = function (_a) {
    var data = _a.data, className = _a.className, clickHandlers = _a.clickHandlers, playIcon = _a.playIcon, role = _a.role;
    if (!data)
        return null;
    var content = null;
    switch (data.kind) {
        case "Video":
            var videoTracking = {
                list: "Program Highlights",
                product: {
                    name: data.title,
                    category: "product clicks",
                },
            };
            content = (React.createElement(Container, { className: className, url: data.slug, trackingObject: videoTracking },
                React.createElement(ImageWrapper, null,
                    React.createElement(Image, { image: data.image, alt: data.title }),
                    React.createElement(PlayDuration, null, data.duration),
                    playIcon &&
                        React.createElement(PlayIcon, { src: "/icons/play-icon-2024.svg", alt: "", "aria-hidden": "true" })),
                React.createElement(Title, null, data.title)));
            break;
        case "Basic":
            var basicObject = {
                list: "Program Highlights",
                product: {
                    name: data.title,
                    category: "product clicks",
                },
            };
            content = (React.createElement(Container, { className: className, url: data.slug, trackingObject: basicObject },
                React.createElement(ImageWrapper, null,
                    React.createElement(Image, { image: data.image, alt: data.title })),
                React.createElement(Title, null, data.title)));
            break;
        case "Ticket":
            var ticketObject = {
                list: "Program Highlights",
                product: {
                    name: data.title,
                    category: "product clicks",
                },
            };
            content = (React.createElement(Container, { className: className, url: data.url, trackingObject: ticketObject },
                React.createElement(ImageWrapper, null,
                    React.createElement(Image, { image: data.image, alt: data.title })),
                React.createElement(Title, null, data.title)));
            break;
        case "Labeled":
            var labeledObject = {
                list: "Program Highlights",
                product: {
                    name: data.title,
                    category: "product clicks",
                },
            };
            content = (React.createElement(Container, { className: className, url: data.slug, trackingObject: labeledObject },
                React.createElement(ImageWrapper, null,
                    React.createElement(Image, { image: data.image, alt: data.title })),
                React.createElement(Title, null, data.title)));
            break;
        default:
            return null;
    }
    return content ? wrapInListItem(content, role === "listitem") : null;
};
var Container = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: 13.333rem;\n  min-height: 13.1875rem;\n  text-decoration: none;\n  cursor: pointer;\n  display: block;\n  margin: 4px;\n\n  &:focus {\n    outline: 3px solid ", ";\n    outline-offset: 2px;\n    border-radius: 0.5rem;\n  }\n\n  ", " {\n    min-width: 8rem;\n    min-height: auto;\n  }\n\n  ", " {\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n\n  ", " {\n    min-width: 10rem;\n  }\n\n  ", " {\n    min-width: 17.25rem;\n  }\n"], ["\n  min-width: 13.333rem;\n  min-height: 13.1875rem;\n  text-decoration: none;\n  cursor: pointer;\n  display: block;\n  margin: 4px;\n\n  &:focus {\n    outline: 3px solid ", ";\n    outline-offset: 2px;\n    border-radius: 0.5rem;\n  }\n\n  ", " {\n    min-width: 8rem;\n    min-height: auto;\n  }\n\n  ", " {\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n\n  ", " {\n    min-width: 10rem;\n  }\n\n  ", " {\n    min-width: 17.25rem;\n  }\n"])), colors.focus, mq.minWidth("64rem"), mq.hover("hover"), colors.white, mq.minWidth("90rem"), mq.minWidth("120rem"));
export var Title = styled.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 0.9375rem;\n  ", "\n  line-height: 1.4;\n  width: 100%;\n  margin: 0;\n"], ["\n  color: ", ";\n  font-size: 0.9375rem;\n  ", "\n  line-height: 1.4;\n  width: 100%;\n  margin: 0;\n"])), colors.white, fontWeight.extraBold);
var PlayIcon = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 24px;\n    height: 24px;\n"], ["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 24px;\n    height: 24px;\n"])));
var ImageWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  pointer-events: none;\n  margin-bottom: 0.5rem;\n  overflow: hidden;\n  position: relative;\n  object-fit: cover;\n  border-radius: 0.5rem;\n  width: 100%;\n\n  img {\n    object-fit: cover;\n  }\n"], ["\n  background-color: ", ";\n  pointer-events: none;\n  margin-bottom: 0.5rem;\n  overflow: hidden;\n  position: relative;\n  object-fit: cover;\n  border-radius: 0.5rem;\n  width: 100%;\n\n  img {\n    object-fit: cover;\n  }\n"])), colors.silver);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
